var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"auto"}},[_c('img',{attrs:{"src":_vm.getImgUrl(_vm.hasRisk),"height":"36"}})]),_c('v-col',[_c('span',{staticClass:"ml-3",class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.category))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }